<div class="overflow-container">
  <textarea
    #itemPropertyField
    type="text"
    class="text-field-input"
    placeholder="Type text here"
    (blur)="onPropertyUpdated($event.target.value)"
    [disabled]="!editable"
    [(ngModel)]="inputValue"
  ></textarea>
</div>
